<template>
	<section class="tool-submission-thank-you-root text-center my-5 py-5" role="status">
		<p class="tool-submission-thank-you-root__message">{{ message || DEFAULT_TOOL_THANK_YOU_MESSAGE }}</p>
		<slot/>
	</section>
</template>

<script>
import {DEFAULT_TOOL_THANK_YOU_MESSAGE} from "@shared/SharedConstants.js";

export default {
	name: "ToolSubmissionThankYouView",
	props: {message: String},
	data() {return {DEFAULT_TOOL_THANK_YOU_MESSAGE}},
}
</script>

<style lang="scss">
.tool-submission-thank-you-root {
	&__message {white-space: pre-line; font-size: 1.5rem;}
}
</style>
